import { useCallback } from 'react';
import { useClient } from 'urql';

import {
  ScanToPayCreditsDocument,
  ScanToPayCreditsQuery,
} from '../../graphql/ScanToPayCredits.generated';

// ────────────────────────────────────────────────────────────────────────────

/**
 * A hook for fetching the available credit amount.
 */
export const useScanToPayCreditBalance = () => {
  const client = useClient();

  // ─── Queries ──────────────────────────────────────────────────────────────

  const fetchCredits = useCallback(async () => {
    const queryCredits = client.query<ScanToPayCreditsQuery>;

    const response = await queryCredits(
      ScanToPayCreditsDocument,
      {},
      { requestPolicy: 'network-only' },
    ).toPromise();

    const availableCredit =
      response.data?.currentCustomer?.availableCredit ?? 0;

    return { availableCredit };
  }, [client.query]);

  // ──────────────────────────────────────────────────────────────────────────

  return { fetchCredits };
};
